export default __webpack_public_path__ + "static/media/01.6230a7d0.jpg";